import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { generateArticleUrl } from '../../utilities.js';

const CsmArticleLink = props => {
    return <Link className={props.className} to={generateArticleUrl(props.article)}>{props.children || props.article.name}</Link>;
};

CsmArticleLink.propTypes = {
    article: PropTypes.object.isRequired,
    children: PropTypes.node,
    className: PropTypes.string
};

export default CsmArticleLink;


// WEBPACK FOOTER //
// ./src/ui/src/component/csmArticlelink/csmArticleLink.js